<template>
  <div v-if="renderable_blocks.length" class="cms-blocks">
    <component
      :is="block.component"
      v-for="block in renderable_blocks"
      :key="`cms-block-${block.type}-${block.index}`"
      v-bind="block.props"
    />
  </div>
</template>

<script>
  /**
   * CMS blocks dispatcher: receives the (ordered) array of a zone and renders
   * the component matching each block.
   *
   * Block format from the API: `{ component: <type>, props: {...} }`. The
   * `component` field selects the Vue component; `props` is spread onto the
   * child with `v-bind` (each key becomes a prop). Blocks with an unmapped
   * `component` are skipped (logged in dev) instead of breaking the rendering
   * of the whole page.
   *
   * The `slider` block is rendered by the shared `hero` component: CMS slides
   * arrive via the `slides` prop (spread by `v-bind`); when absent, `hero` falls
   * back to the config slides (`sliderHome.*`).
   */
  import { get_renderable_blocks } from './content-utilities';
  import Hero from './hero.vue';
  import TextImage from './text-image.vue';
  import TextImageAlt from './text-image-alt.vue';
  import TextColumns from './text-columns.vue';
  import Assistance from './assistance.vue';

  // API `component` field value => Vue component tag
  const BLOCK_COMPONENTS = {
    slider: 'hero',
    'text-image': 'text-image',
    'text-image-alt': 'text-image-alt',
    'text-columns': 'text-columns',
    assistance: 'assistance',
  };

  export default {
    name: 'content-blocks',

    components: {
      hero: Hero,
      'text-image': TextImage,
      'text-image-alt': TextImageAlt,
      'text-columns': TextColumns,
      assistance: Assistance,
    },

    props: {
      blocks: {
        type: Array,
        default: () => [],
      },
    },

    computed: {
      renderable_blocks() {
        return get_renderable_blocks(this.blocks, BLOCK_COMPONENTS, (type) =>
          this.log(`[content-blocks] unhandled block component: ${type}`)
        );
      },
    },
  };
</script>
